module.exports = __webpack_public_path__ + "img/126.7e1d88e6.jpg";